export const IS_ALL_SSR = process.env.REACT_APP_IS_ALL_SSR === 'true';
